import { render, staticRenderFns } from "./NotificationsListElement.vue?vue&type=template&id=6d7d34a5&scoped=true"
import script from "./NotificationsListElement.vue?vue&type=script&lang=js"
export * from "./NotificationsListElement.vue?vue&type=script&lang=js"
import style0 from "./NotificationsListElement.vue?vue&type=style&index=0&id=6d7d34a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7d34a5",
  null
  
)

export default component.exports